import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStartVm } from 'src/common/hooks/use-start-vm';
import { useAppDispatch } from 'src/app/hooks';
import { setMessage } from 'src/app/reducers/split-screen.reducer';
import { useElementObserver } from 'src/common/hooks/use-element-observer';
import { ContentButton } from '../../tasks/components/accordion/content-button';
import { useHasAnsweredAllQuestionsCorrectly } from '../hooks/use-has-answered-all-questions-correctly';
import { TaskContentButtonProps } from './task-content-button.types';
export const TaskContentButton = ({
  taskNo,
  roomId,
  taskId,
  roomCode,
  taskType,
  uploadId,
  currentTask,
  activeMachine,
  shouldSeeVmStart,
  tasks
}: TaskContentButtonProps) => {
  const [isDesktopOnlyAccessPopupOpen, setIsDesktopOnlyAccessPopupOpen] = useState(false);
  const {
    startVmHandler
  } = useStartVm(roomCode);
  const dispatch = useAppDispatch();
  const hasSeenVmStartRef = useRef<boolean>(false);
  const hasAnsweredAllRoomQuestionsCorrectly = useHasAnsweredAllQuestionsCorrectly(tasks);
  const taskCtaElement = useElementObserver(`task-cta-${taskNo}`);
  useEffect(() => {
    if (activeMachine) {
      hasSeenVmStartRef.current = true;
    }
    if (!shouldSeeVmStart || activeMachine || hasSeenVmStartRef.current || hasAnsweredAllRoomQuestionsCorrectly) {
      return;
    }
    const startVmAsync = async () => {
      hasSeenVmStartRef.current = true;
      dispatch(setMessage('It can take 1-2 minutes to fully load'));
      await startVmHandler('Deploy', currentTask.uploadId, currentTask._id);
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    startVmAsync();
  }, [activeMachine, currentTask._id, currentTask.uploadId, dispatch, shouldSeeVmStart, startVmHandler, hasAnsweredAllRoomQuestionsCorrectly]);
  const contentButton = <ContentButton roomCode={roomCode} type={taskType} taskId={taskId} uploadId={uploadId} roomId={roomId} taskNo={taskNo} applyDefaultStyles={!taskCtaElement} isDesktopOnlyAccessPopupOpen={isDesktopOnlyAccessPopupOpen} setIsDesktopOnlyAccessPopupOpen={setIsDesktopOnlyAccessPopupOpen} hasSeenVmStart={hasSeenVmStartRef.current} isAttackboxWidgetV1ExperimentEnabled={false} isAttackboxWidgetV2ExperimentEnabled={false} isDisabled={hasAnsweredAllRoomQuestionsCorrectly} staticSite={currentTask.staticSite} />;
  return taskCtaElement ? createPortal(contentButton, taskCtaElement) : contentButton;
};